/**
 * @pageName EventDetails
 * @slotType site plugin
 */
export interface EventDetailsProps {
  /* The ID of the event that is currently applied on the plugin's host.*/ eventId: string;
}
export const SlotIds = {
  header: 'c9fa4cb6-396e-4d66-9624-0716f5b01f4a',
  details: '558afc1d-0369-4366-9418-027c9d4b99db',
};
